export default __webpack_public_path__ + "static/POST FORMING LAMINATES-be17dc7e833289ce2518da1170595710.webp";